import { useEffect, useRef } from 'react';
import { useShift } from '../contexts/ShiftContext';
import { useSession } from '../contexts/SessionContext';
import { getAllPatients } from '../constants/mockPatients';

/** Seeds ward tasks when on shift. Does not gate/blur the UI (start-shift bar removed). */
export default function ShiftGate({ children }) {
  const { isOnShift } = useShift();
  const { admittedPatients, ensureDefaultRecurringTasks } = useSession();
  const didInitRef = useRef(false);

  useEffect(() => {
    if (!isOnShift) {
      didInitRef.current = false;
      return;
    }
    if (didInitRef.current) return;
    didInitRef.current = true;
    const roster = getAllPatients(admittedPatients);
    roster.forEach((patient) => {
      ensureDefaultRecurringTasks(patient, new Date(), { carryFromPreviousShift: true });
    });
  }, [admittedPatients, ensureDefaultRecurringTasks, isOnShift]);

  return children;
}
